module.exports = __webpack_public_path__ + "img/bandera_catalunya.eaa6aee4.svg";